import type { TripListPrice } from './tripListTypes'
import { computeCartPanelTotal } from '../../utils/cartPanelUtils'

export interface TripListFooterTotalPrice {
  total: number
  currency: string
}

export function getValidTripListMemberPrice(price: TripListPrice): number | undefined {
  if (price.price === undefined) return undefined
  if (price.memberPrice === undefined) return undefined
  if (price.memberPrice <= 0) return undefined
  if (price.memberPrice >= price.price) return undefined
  return price.memberPrice
}

export function getTripListDisplayPrice(price: TripListPrice, luxPlusEnabled: boolean): number | undefined {
  if (luxPlusEnabled) {
    const memberPrice = getValidTripListMemberPrice(price)
    if (memberPrice !== undefined) return memberPrice
  }

  return price.price
}

export function getTripListFooterTotalPrice(prices: Array<TripListPrice>, luxPlusEnabled: boolean): TripListFooterTotalPrice | undefined {
  let currency: string | undefined
  const totalItems = []

  for (const price of prices) {
    if (price.price === undefined || !price.currency) continue
    if (currency && currency !== price.currency) return undefined
    currency = price.currency
    totalItems.push({
      cartExcluded: false,
      price: price.price,
      memberPrice: price.memberPrice,
      includeInTotal: true,
      includeInCount: true,
    })
  }

  if (!currency) return undefined

  return {
    total: computeCartPanelTotal(totalItems, luxPlusEnabled).totalPrice,
    currency,
  }
}
